module.exports = __webpack_public_path__ + "static/img/4021.001cb22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/components/4021.png
// module id = 728
// module chunks = 0 1 12